import { useState } from 'react';
import { X } from 'lucide-react';

const TemplateCard = ({ t, api, onSaved, canEdit }) => {
  const [name, setName] = useState(t.name);
  const [body, setBody] = useState(t.body);
  const [msg, setMsg] = useState('');
  const save = async () => {
    setMsg('');
    const res = await api(`/templates/${t.key}`, { method: 'PUT', body: JSON.stringify({ name, body }) }, true);
    if (res?.error) setMsg(res.error); else { setMsg('Saved'); onSaved(res.templates); }
  };
  return (
    <div className="rounded-xl border border-slate-200 p-4 space-y-2" data-testid={`template-card-${t.key}`}>
      <input disabled={!canEdit} value={name} onChange={(e) => setName(e.target.value)} className="w-full font-semibold text-slate-900 border-b border-transparent focus:border-teal-400 focus:outline-none" data-testid={`template-name-${t.key}`} />
      <textarea disabled={!canEdit} value={body} onChange={(e) => setBody(e.target.value)} rows={6} className="w-full rounded-lg border border-slate-200 p-2.5 text-sm focus:outline-none focus:ring-2 focus:ring-teal-400" data-testid={`template-body-${t.key}`} />
      <div className="flex items-center justify-between text-xs text-slate-400">
        <span>Last edited by {t.updated_by} · {new Date(t.updated_at).toLocaleDateString('en-IN')}</span>
        {canEdit && <button type="button" onClick={save} className="rounded-full bg-[#0b1f4d] text-white font-semibold px-4 py-1.5" data-testid={`template-save-${t.key}`}>Save</button>}
      </div>
      {msg && <p className={`text-xs ${msg === 'Saved' ? 'text-teal-700' : 'text-rose-600'}`} data-testid={`template-msg-${t.key}`}>{msg}</p>}
    </div>
  );
};

export const TemplatesPanel = ({ templates, placeholders, api, onSaved, onClose, canEdit }) => (
  <div className="fixed inset-0 z-50 flex justify-end" data-testid="templates-panel">
    <div className="absolute inset-0 bg-slate-900/30" onClick={onClose} />
    <aside className="relative w-full max-w-xl bg-white h-full overflow-y-auto shadow-2xl p-6 space-y-4">
      <button type="button" onClick={onClose} className="absolute right-4 top-4 text-slate-400 hover:text-slate-700" data-testid="templates-close-btn"><X className="w-5 h-5" /></button>
      <h3 className="font-outfit text-xl font-bold text-[#0b1f4d]">WhatsApp message templates</h3>
      <p className="text-xs text-slate-500">Placeholders: {placeholders.map((p) => <code key={p} className="bg-slate-100 rounded px-1 mx-0.5">{`{${p}}`}</code>)}. If a student is missing a value, they're excluded from that template rather than given a made-up one. Never promise jobs or placements.</p>
      {templates.map((t) => <TemplateCard key={t.key} t={t} api={api} onSaved={onSaved} canEdit={canEdit} />)}
    </aside>
  </div>
);
